/**
 * @generated SignedSource<<6edb4383a4b5a07ed72f23bd82df506d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhaseItem_phase$data = {
  readonly color: string;
  readonly end_date: string | null | undefined;
  readonly id: number;
  readonly name: string;
  readonly project_id: number;
  readonly revenue_budget: number | null | undefined;
  readonly start_date: string | null | undefined;
  readonly " $fragmentType": "PhaseItem_phase";
};
export type PhaseItem_phase$key = {
  readonly " $data"?: PhaseItem_phase$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhaseItem_phase">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhaseItem_phase",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": "start_date",
      "args": null,
      "kind": "ScalarField",
      "name": "start_date_runn",
      "storageKey": null
    },
    {
      "alias": "end_date",
      "args": null,
      "kind": "ScalarField",
      "name": "end_date_runn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "project_id",
      "storageKey": null
    },
    {
      "alias": "revenue_budget",
      "args": null,
      "kind": "ScalarField",
      "name": "revenue_budget_private",
      "storageKey": null
    }
  ],
  "type": "phases",
  "abstractKey": null
};

(node as any).hash = "c8b179199ad672a8111985689db6a9a5";

export default node;
